import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api`;

// Keep doctor and admin tokens in separate storage keys so an admin
// browsing the site as a "guest" doctor never accidentally attaches an
// admin JWT to public content endpoints (and vice-versa).
const TK_ACCESS = "tg_doctor_access";
const TK_REFRESH = "tg_doctor_refresh";
const TK_ME = "tg_doctor_me";

export const doctorToken = {
  get access() { return localStorage.getItem(TK_ACCESS); },
  get refresh() { return localStorage.getItem(TK_REFRESH); },
  get me() { try { return JSON.parse(localStorage.getItem(TK_ME) || "null"); } catch { return null; } },
  set({ access_token, refresh_token, doctor }) {
    if (access_token) localStorage.setItem(TK_ACCESS, access_token);
    if (refresh_token) localStorage.setItem(TK_REFRESH, refresh_token);
    if (doctor) localStorage.setItem(TK_ME, JSON.stringify(doctor));
  },
  clear() { localStorage.removeItem(TK_ACCESS); localStorage.removeItem(TK_REFRESH); localStorage.removeItem(TK_ME); }
};

export const doctorApi = axios.create({ baseURL: BASE, timeout: 15000 });
doctorApi.interceptors.request.use((cfg) => {
  const t = doctorToken.access;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const doctorAuth = {
  register: (payload) => doctorApi.post("/doctor/register", payload).then(r => r.data),
  login: (email, password) => doctorApi.post("/doctor/login", { email, password }).then(r => r.data),
  me: () => doctorApi.get("/doctor/me").then(r => r.data),
  logout: () => doctorApi.post("/doctor/logout").then(r => r.data),
  portalConfig: () => doctorApi.get("/doctor/portal-config").then(r => r.data),
};
